<template>
	<div class="BasePieChart">
		<div ref="PieChart" style="width: 100%; height: 230px; overflow: hidden;"></div>
		<div class="flex justify-around text-xs m-1">
			<p v-for="(item, index) in data" :key="index" class="mx-2 text center">{{item.value}}%</p>
		</div>
		<!-- <div v-else>
			<h3 style="text-align: center; padding-top: 50px;">No Data Found</h3>
		</div> -->
	</div>
</template>
<script>
var echarts = require("echarts");
import { GraphData } from "../../../../mixins/basePieChartGraph.js";
import { EventBus } from "../../../eventBus.js";
import moment from "moment";

export default {
	name: "BasePieChart",
	mixins: [GraphData],
	props: {
		graphDetails: {
			type: Array,
			default: () => []
		},
		graphSingleData: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			daySchdulerGraphInstance: "",
			colors: [" #e29d5a", "#F9CB9C", "#FCE5CD"],
			// colors: ["#a3a1fb","#c9daf8", "#f9acaa"],
			// colors: ["#66cc66", "#8000ff", "#ffa31a", "#80d4ff", "#b30000"],
			isGraphDataAvailable: true,
			data: []
		};
	},
	mounted() {
		// this.initBwaseGraph();
		// this.map_graph_data(this.graphDetails, this.graphSingleData);
			this.initBaseGraph();
		EventBus.$on("reponsePieChart", data => {
			// this.clearGraph();
            console.log(data);
			this.map_graph_data(data);
		});
	},
	beforeDestroy() {
		EventBus.$off();
	},
	methods: {
		map_graph_data(graph_data) {
			this.graphSeries = [];
			this.graphColors = this.colors;
			// this.getNameOfGraph = "PT %"
			this.getTitle.text = "Flexible(Part Time/Hourly)%"
			let Actual = {
				name: "",
				type: "pie",
				radius: ['30%', '42%'],
                data: [],
				label: {
					show: false,
					position: 'center'
				},
			};
			if (graph_data.length) {
				this.data = graph_data;
                Actual.data = graph_data;
				this.graphSeries.push(Actual);
			} else {
				this.isGraphDataAvailable = false;
			}

			this.reRenderGraph();
			// console.log("graphData", this.graphData);
		},

		clearGraph: function() {
			this.daySchdulerGraphInstance.clear();
		},

		reRenderGraph: function() {
			this.clearGraph();
			this.daySchdulerGraphInstance.setOption(this.graphData);
			this.daySchdulerGraphInstance.hideLoading();
		},

		initBaseGraph() {
			let baseGraphContainer = this.$refs["PieChart"];
			this.daySchdulerGraphInstance = echarts.init(
				baseGraphContainer,
				null,
				this.initOptions
			);
			this.daySchdulerGraphInstance.showLoading();
		}
	}
};
</script>
<style lang="scss" scoped>
.BasePieChart {
	margin: 0 10px;
}
</style>>
